(function () {
  'use strict';

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  function clamp(n, min, max) {
    if (isNaN(n)) return min;
    if (n < min) return min;
    if (n > max) return max;
    return n;
  }

  // === Scroll reveal ===
  function initScrollReveal() {
    var els = document.querySelectorAll('.shudo .shudo-reveal, .shudo-reveal');
    if (!els || !els.length) return;

    if (typeof IntersectionObserver === 'undefined') {
      for (var i = 0; i < els.length; i++) els[i].classList.add('visible');
      return;
    }

    var observer = new IntersectionObserver(function (entries, obs) {
      for (var i = 0; i < entries.length; i++) {
        var entry = entries[i];
        if (entry.isIntersecting) {
          entry.target.classList.add('visible');
          obs.unobserve(entry.target);
        }
      }
    }, {
      threshold: 0.15,
      rootMargin: '0px 0px -50px 0px'
    });

    for (var j = 0; j < els.length; j++) observer.observe(els[j]);
  }

  // === FAQ (small enhancement: single-open behavior on native <details>) ===
  function initFaq() {
    var items = document.querySelectorAll('.shudo .shudo-faq-item, .shudo-faq-item');
    if (!items || !items.length) return;

    for (var i = 0; i < items.length; i++) {
      (function (item) {
        var summary = item.querySelector('.shudo-faq-question');
        if (!summary) return;
        summary.addEventListener('click', function () {
          // If this one is about to open, close the others
          if (!item.hasAttribute('open')) {
            for (var k = 0; k < items.length; k++) {
              if (items[k] !== item && items[k].hasAttribute('open')) {
                items[k].removeAttribute('open');
              }
            }
          }
        });
      })(items[i]);
    }
  }

  // === Subscription toggle ===
  function initSubscriptionToggle() {
    var buttons = document.querySelectorAll('.shudo .shudo-toggle-btn, .shudo-toggle-btn');
    if (!buttons || !buttons.length) return;

    var priceEl = document.querySelector('.shudo .shudo-product-card__price') ||
                  document.querySelector('.shudo-product-card__price');
    var ctaEl = document.querySelector('.shudo .shudo-add-to-cart') ||
                document.querySelector('.shudo-add-to-cart');

    var basePriceString = null;
    var basePriceNumber = null;
    var ctaOriginalText = null;
    var ctaOriginalPriceString = null;

    if (priceEl) {
      var baseAttr = priceEl.getAttribute('data-base-price');
      if (baseAttr && baseAttr.length) {
        basePriceString = baseAttr;
      } else {
        basePriceString = (priceEl.textContent || '').trim();
        priceEl.setAttribute('data-base-price', basePriceString);
      }
      var match = basePriceString.match(/(\d+(?:[.,]\d+)?)/);
      if (match) {
        basePriceNumber = parseFloat(match[1].replace(',', '.'));
      }
    }

    if (ctaEl) {
      ctaOriginalText = (ctaEl.textContent || '').trim();
      // The trailing price (after em-dash) of the CTA — capture for restore.
      var ctaMatch = ctaOriginalText.match(/(\d+(?:[.,]\d+)?[^\d]*)$/);
      if (ctaMatch) ctaOriginalPriceString = ctaMatch[1].trim();
    }

    function formatPrice(numberValue) {
      if (!basePriceString || basePriceNumber === null) return basePriceString || '';
      var original = basePriceString.match(/(\d+(?:[.,]\d+)?)/);
      if (!original) return basePriceString;
      var originalNumStr = original[1];
      var hasDecimal = /[.,]/.test(originalNumStr);
      var separator = originalNumStr.indexOf(',') > -1 ? ',' : '.';
      var newStr;
      if (hasDecimal) {
        newStr = numberValue.toFixed(2);
        if (separator === ',') newStr = newStr.replace('.', ',');
      } else {
        newStr = String(Math.round(numberValue));
      }
      return basePriceString.replace(originalNumStr, newStr);
    }

    function updateCtaPrice(newPriceString) {
      if (!ctaEl || !ctaOriginalText) return;
      // Replace the trailing price portion after the em-dash in the CTA text.
      var emDashIdx = ctaOriginalText.indexOf('—');
      if (emDashIdx === -1) emDashIdx = ctaOriginalText.indexOf('—');
      if (emDashIdx === -1) {
        ctaEl.textContent = ctaOriginalText;
        return;
      }
      var prefix = ctaOriginalText.slice(0, emDashIdx + 1);
      ctaEl.textContent = prefix + ' ' + newPriceString;
    }

    function setActive(clicked) {
      for (var i = 0; i < buttons.length; i++) {
        buttons[i].classList.remove('active');
        buttons[i].setAttribute('aria-pressed', 'false');
      }
      clicked.classList.add('active');
      clicked.setAttribute('aria-pressed', 'true');

      var mode = clicked.getAttribute('data-mode');

      if (priceEl && basePriceNumber !== null) {
        if (mode === 'subscribe') {
          var newPrice = formatPrice(basePriceNumber * 0.85);
          priceEl.textContent = newPrice;
          updateCtaPrice(newPrice);
        } else {
          priceEl.textContent = basePriceString;
          if (ctaEl && ctaOriginalText !== null) {
            ctaEl.textContent = ctaOriginalText;
          }
        }
      }
    }

    for (var i = 0; i < buttons.length; i++) {
      (function (btn) {
        btn.addEventListener('click', function (e) {
          e.preventDefault();
          setActive(btn);
        });
      })(buttons[i]);
    }
  }

  // === Quantity selector ===
  function initQuantity() {
    var containers = document.querySelectorAll('.shudo .shudo-qty, .shudo-qty');
    if (!containers || !containers.length) return;

    for (var i = 0; i < containers.length; i++) {
      (function (container) {
        var minusBtn = container.querySelector('[data-qty="decrement"]');
        var plusBtn = container.querySelector('[data-qty="increment"]');
        var input = container.querySelector('.shudo-qty-input');
        if (!input) return;

        function getVal() {
          return clamp(parseInt(input.value, 10), 1, 99);
        }

        function setVal(v) {
          input.value = clamp(v, 1, 99);
        }

        if (plusBtn) {
          plusBtn.addEventListener('click', function (e) {
            e.preventDefault();
            setVal(getVal() + 1);
          });
        }

        if (minusBtn) {
          minusBtn.addEventListener('click', function (e) {
            e.preventDefault();
            setVal(getVal() - 1);
          });
        }

        input.addEventListener('change', function () {
          setVal(parseInt(input.value, 10));
        });

        input.addEventListener('blur', function () {
          setVal(parseInt(input.value, 10));
        });
      })(containers[i]);
    }
  }

  // === Add to cart ===
  function initAddToCart() {
    var forms = document.querySelectorAll('.shudo .shudo-product-form, .shudo-product-form');
    if (!forms || !forms.length) return;

    for (var i = 0; i < forms.length; i++) {
      (function (form) {
        var btn = form.querySelector('.shudo-add-to-cart');
        if (!btn) return;

        var busy = false;

        function findQtyInput() {
          var card = form.closest('.shudo-product-card') || form.closest('.shudo') || document;
          return card.querySelector('.shudo-qty-input');
        }

        function findVariantId() {
          // Prefer button attribute, then hidden input.
          var id = btn.getAttribute('data-variant-id');
          if (id) return id;
          var hidden = form.querySelector('.shudo-variant-id') ||
                       form.querySelector('input[name="id"]');
          return hidden ? hidden.value : null;
        }

        function updateCartCount() {
          fetch('/cart.js', {
            credentials: 'same-origin',
            headers: { 'Accept': 'application/json' }
          })
            .then(function (r) { return r.json(); })
            .then(function (cart) {
              var counters = document.querySelectorAll('[data-cart-count]');
              for (var i = 0; i < counters.length; i++) {
                counters[i].textContent = cart.item_count;
              }
            })
            .catch(function (err) {
              console.error('[shudolabs] cart count fetch failed', err);
            });
        }

        function flashState(text, bg, restoreText, restoreBg) {
          btn.textContent = text;
          if (bg) btn.style.backgroundColor = bg;
          setTimeout(function () {
            btn.textContent = restoreText;
            btn.style.backgroundColor = restoreBg || '';
            busy = false;
          }, 2200);
        }

        form.addEventListener('submit', function (e) {
          e.preventDefault();
          if (busy) return;
          busy = true;

          var variantId = findVariantId();
          var qtyInput = findQtyInput();
          var qty = qtyInput ? clamp(parseInt(qtyInput.value, 10), 1, 99) : 1;

          var originalText = btn.textContent;
          var originalBg = btn.style.backgroundColor;

          if (!variantId) {
            // No real product configured — simulate success for preview mode
            flashState('✓ ADDED TO STACK', '#3D6B1F', originalText, originalBg);
            return;
          }

          fetch('/cart/add.js', {
            method: 'POST',
            credentials: 'same-origin',
            headers: {
              'Content-Type': 'application/json',
              'Accept': 'application/json'
            },
            body: JSON.stringify({ id: variantId, quantity: qty })
          })
            .then(function (res) {
              if (!res.ok) {
                return res.json().then(function (data) {
                  throw new Error((data && data.description) || ('HTTP ' + res.status));
                });
              }
              return res.json();
            })
            .then(function () {
              flashState('✓ ADDED TO STACK', '#3D6B1F', originalText, originalBg);
              updateCartCount();
            })
            .catch(function (err) {
              console.error('[shudolabs] add to cart failed', err);
              flashState('ERROR — TRY AGAIN', '', originalText, originalBg);
            });
        });
      })(forms[i]);
    }
  }

  // === Smooth scroll ===
  function initSmoothScroll() {
    var root = document.querySelector('.shudo');
    if (!root) return;

    var links = root.querySelectorAll('a[href^="#shudo-"]');
    if (!links || !links.length) return;

    for (var i = 0; i < links.length; i++) {
      (function (link) {
        link.addEventListener('click', function (e) {
          var href = link.getAttribute('href');
          if (!href || href.length < 2) return;
          var id = href.slice(1);
          var target = document.getElementById(id);
          if (!target) return;
          e.preventDefault();
          var offset = 0;
          var rect = target.getBoundingClientRect();
          var top = rect.top + window.pageYOffset - offset;
          if ('scrollBehavior' in document.documentElement.style) {
            window.scrollTo({ top: top, behavior: 'smooth' });
          } else {
            window.scrollTo(0, top);
          }
        });
      })(links[i]);
    }
  }

  ready(function () {
    initScrollReveal();
    initFaq();
    initSubscriptionToggle();
    initQuantity();
    initAddToCart();
    initSmoothScroll();
  });
})();
